import { render, staticRenderFns } from "./DeviceTabPanels.vue?vue&type=template&id=36e977b6&"
import script from "./DeviceTabPanels.vue?vue&type=script&lang=ts&"
export * from "./DeviceTabPanels.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QTabPanels,QTabPanel,QExpansionItem,QItemSection,QIcon,QMenu,QItem,QBtn,QList,QItemLabel,QSelect,QTooltip,QDialog,QCard,QCardSection,QRadio,QCardActions,ClosePopup,Ripple} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QTabPanels,QTabPanel,QExpansionItem,QItemSection,QIcon,QMenu,QItem,QBtn,QList,QItemLabel,QSelect,QTooltip,QDialog,QCard,QCardSection,QRadio,QCardActions})
component.options.directives = Object.assign(Object.create(component.options.directives || null), component.options.directives || {}, {ClosePopup,Ripple})
